import type { ReactNode } from "react";
import classnames from "classnames";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";

export interface ClearButtonProps {
  children: ReactNode;
  onButtonClick?: () => void;
  onClick?: () => void;
}

export const ClearButton = ({
  children,
  onClick,
  onButtonClick,
}: ClearButtonProps) => (
  <div className="flex items-center">
    <Button
      variant="secondary"
      type="button"
      className={classnames(
        "rounded-r-none border-r-0 !pl-3 !pr-2 !font-light",
        {
          "pointer-events-none": !onButtonClick,
        },
      )}
      onClick={onButtonClick}
    >
      {children}
    </Button>
    <div className="ml-[-1px]">
      <Button
        type="button"
        onClick={onClick}
        variant="secondary"
        className="rounded-l-none border-l-0 !px-1.5"
        data-testid="clear-action-button"
        aria-label={t("clear")}
        title={t("clear")}
      >
        <Icon aria-hidden type="16-close" size={16} className="mb-[1px]" />
      </Button>
    </div>
  </div>
);
